// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"6362b5c5","152":"2c22c43a","198":"5c830e18","345":"e56883c8","362":"e83e6b87","404":"3ac5f455","480":"52cf6e5d","541":"1550e6af","549":"396caab8","579":"f6c72d3f","622":"fa73e2bb","854":"10515221","930":"bced326f"}[chunkId] + ".chunk.js";
};